"use strict";
/*
 * Created on 5.12.2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var SessionInfoConverter_1 = require("./conversions/SessionInfoConverter");

var SessionInfoConverterImpl_1 = require("./conversions/SessionInfoConverterImpl");

var SessionItemConverter_1 = require("./conversions/SessionItemConverter");

var SessionItemConverterImpl_1 = require("./conversions/SessionItemConverterImpl");
/**
 * @author MSu
 */


var UserSessionAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(UserSessionAppModule, _AppModule_1$AppModul);

  function UserSessionAppModule() {
    var _this;

    _classCallCheck(this, UserSessionAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UserSessionAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'userSessionAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(UserSessionAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(SessionInfoConverter_1.SessionInfoConverter).to(SessionInfoConverterImpl_1.SessionInfoConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SessionItemConverter_1.SessionItemConverter).to(SessionItemConverterImpl_1.SessionItemConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return UserSessionAppModule;
}(AppModule_1.AppModule);

exports.UserSessionAppModule = UserSessionAppModule;